import { Injectable } from '@angular/core';

import { TreeNode } from 'primeng/api';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class NodeService {

     constructor(private http: HttpClient) {}
   getFilesystem() {
    // console.warn('her we are');
    //environment.getAemurl()+'/json/Api.json'
     //http://localhost:4200/assets/Data/Api.json

     return this.http.get<any>(environment.getAemurl()+'/json/Api.json')
      .toPromise()
      .then(res => res.data as TreeNode[]);
    }
}
